module.exports = __webpack_public_path__ + "static/media/safari-pwa-1.dc6f8aa2.svg";